const servicesData = {
  'web-development': {
    title: 'Build Fast, Secure, and Stunning Websites',
    // subtitle: 'Websites That Truly Stand Out',
    description:
      'Make unforgettable impressions with purpose-built websites that are visually appealing, effortless to navigate, and simple to manage. Our websites improve engagement and satisfaction through responsive, user-friendly designs, while you enjoy an edge over competitors.',
    serviceText: {
      title: 'Our Services',
      intro:
        'Build a powerful digital presence with tailored solutions that captivate visitors and convert them into loyal customers.',
      cards: [
        {
          icon: "/allservices/web development/1.png",
          title: "UI/UX Designs",
          text:
            "We design eye-catching, brand-focused interfaces that capture attention and reflect your business identity. Our custom themes ensure your website not only looks amazing but also creates a lasting impression on every visitor. Through intuitive navigation and engaging design, we craft seamless user experiences that keep audiences coming back for more. Proudly delivered by Shabdd Technology."},
        {
          icon: "/allservices/web development/2.png",
          title: "Landing Page",
          text:
            "Your business identity shines through with brand‑focused, eye‑catching interfaces that instantly capture attention. Our custom themes guarantee your website looks amazing and leaves a lasting impression on every visitor. By combining engaging design with intuitive navigation, we deliver seamless user experiences that encourage audiences to return again and again."},
        { 
          icon: "/allservices/web development/3.png",
          title: 'E-commerce Website',
          text:
            'Transform casual visitors into loyal buyers with seamless, high-performing e-commerce websites. Built for speed, security, and maximum conversions, our platforms deliver a perfect balance of stunning design and powerful functionality. We create conversion-driven e-commerce solutions with intuitive navigation, optimized product pages, and secure, hassle-free payment integrations to boost sales and customer trust.',
        },
        {
          icon: "/allservices/web development/4.png",
          title: 'Responsive Website',
          text:
            "Deliver a flawless browsing experience across all devices from smartphones and tablets to widescreen monitors. Our responsive web designs adapt perfectly to any screen size, ensuring maximum functionality and engagement. We build mobile-friendly, fast-loading websites that enhance user experience, boost search engine rankings, and keep visitors connected with your brand anytime, anywhere. ",
        },

        {
          icon: "/allservices/web development/5.png",
          title:"Content Writing",
          text:"Tell your brand's story with compelling, SEO-optimized content that informs, engages, and drives results. Our writers are seasoned experts, skilled in capturing your audience's attention and driving meaningful interactions. We develop persuasive, well-structured copy that strengthens your brand voice, boosts organic search rankings, and keeps visitors coming back for more."
        },

        {
          icon: "/allservices/web development/6.png",
          title:"Website Revamp",
          text:"Transform your outdated site into a modern, high-performing digital experience. Our website revamp services focus on fresh, visually appealing designs, optimized functionality, and seamless user experiences — with a touch of AI-powered efficiency to save time and costs. We breathe new life into your online presence with improved navigation, faster performance, and conversion-driven optimizations that help your brand stand out and grow."
        }


      ],
    },
  },
  'web-application': {
    
    title: 'Next Gen Web Applications',
    // subtitle: 'Web Application Development Services',
    description:
      "We build high-performance web applications that work smarter, scale effortlessly, and deliver real value. Whether you're automating workflows, integrating AI, or launching a next-gen SaaS, we turn your vision into reality.",
    serviceText: {
      title: 'Custom Web Applications Delivered at Pace',
      intro:
        'The future of web apps is AI-powered, dynamic, immersive, and intelligent – the kind that solves real business without you explaining it. Whether you’re a startup disrupting the market or an enterprise streamlining operations, we build solutions tailored to you.',
      cards: [
        {
          icon: "/allservices/webApp/1.png",
          title: 'Progressive Web Apps (PWAs)',
          text:
            'Fast, offline-ready, and mobile-first for seamless user experiences without app store downloads.',
        },
        {
          icon: "/allservices/webApp/2.png",
          title: 'Enterprise Web Applications',
          text:
            'Scalable platforms that integrate business systems, automate workflows, and enhance operations.',
        },
        {
          icon: "/allservices/webApp/3.png",
          title: 'SaaS & Platform Development',
          text:
            'Multi-tenant, API-driven SaaS platforms built for growth, flexibility, and global accessibility.',
        },

      ],
    },
  },
  'digital-marketing': {
    
    title: 'Drive Engagement and Conversions',
    // subtitle: 'Get Qualified Enrollments Leads with Shabdd Innovations',
    description:
      'Increase your online visibility and boost your student enrollments with proven and tested digital marketing strategies.',
    serviceText: {
      title: 'Our Lead Process',
      intro:
        'Your digital marketing strategy plays a pivotal role in elevating awareness, building a strong brand presence, meeting enrollment targets, and cultivating a diverse network of advocates who will support your institution for years to come.',
      cards: [
        {
          icon: "/allservices/digital/1.png",
          title: 'Personalized Strategy',
          text:
            'We utilize advanced analytics, tracking, and CRM tools to gain insights into your target audience, ensuring data-driven decision-making.',
        },
        {
          icon: "/allservices/digital/2.png",
          title: 'Engaging Content Creation',
          text:
            'We craft compelling, informative, and visually appealing content—blogs, videos, testimonials, and infographics - that resonate with prospective students and drive engagement.',
        },
        {
          icon: "/allservices/digital/3.png",
          title: 'Campaign Execution',
          text:
            'Our highly targeted campaign execution enables you to reach your prospects cost-effectively through PPC, social media, email marketing, and SEO strategies.',
        },
        {
          icon: "/allservices/digital/4.png",
          title: 'Multichannel Lead Nurturing',
          text:
            'We implement automated email sequences, chatbots, and retargeting ads to guide potential students through their decision-making journey and keep them engaged.',
        },
        {
          icon: "/allservices/digital/5.png",
          title:"Lead Conversion",
          text:"Our highly targeted campaign execution enables you to reach your prospects cost-effectively through PPC, social media, email marketing, and SEO strategies."
        },
        {
          icon: "/allservices/digital/6.png",
          title:"Performance Optimization",
          text:"We continuously analyze campaign performance, optimize messaging, and refine targeting strategies to maximize enrollments and ensure long-term success."
        }
      ],
    },
  },
  seo: {
    title: 'SEO Management',
    // subtitle: 'Search Engine Optimization',
    description:
      'Enhance your website performance with SEO strategies that increase organic traffic, improve rankings, and strengthen your long-term digital presence.',
    serviceText: {
      title: 'Why Choose Our SEO Management Services?​',
      intro:
        'At Shabdd Technologies, we don’t just optimize websites—we create powerful SEO strategies that drive real results and fuel business growth. Here’s why our SEO management services are the perfect solution for boosting your online presence:',
      cards: [
        {
          icon: "/allservices/seo/1.jpeg",
          title: 'Data-Driven Approach',
          text:
            'We believe in the power of data to drive informed decision-making. Our SEO strategies are backed by thorough research and the latest analytical tools to ensure every move we make is calculated and purposeful. By analyzing search trends, user behavior, and competitive landscapes, we create optimized campaigns that are rooted in data. This ensures that our efforts are effective in boosting your rankings, driving traffic, and enhancing your overall online performance.',
        },
        {
          icon: "/allservices/seo/2.jpeg",
          title: 'Proven Results',
          text:
            'Our SEO efforts are focused on delivering tangible, measurable outcomes. From improved keyword rankings to increased organic traffic and higher conversion rates, we provide clear, data-backed evidence of success. Our clients consistently see significant improvements in search engine visibility, website traffic, and overall business growth, making our SEO solutions a smart investment for long-term success.',
        },
        {
          icon: "/allservices/seo/3.jpeg",
          title: 'White-Hat Techniques',
          text:
            'At Shabdd Technologies, we prioritize ethical SEO practices that adhere to search engine guidelines. We avoid shortcuts and black-hat tactics that could lead to penalties, ensuring your website’s integrity is never compromised. By using proven, white-hat techniques such as quality content creation, ethical link building, and proper site structure, we help your business achieve sustainable, long-term growth without the risk of penalization.',
        },
        {
          icon: "/allservices/seo/4.jpeg",
          title: 'Ongoing Optimization',
          text:
            'SEO isn’t a one-time task; it’s an ongoing process that requires regular adjustments to stay competitive. At Shabdd Technologies, we continuously monitor your website’s performance, search engine algorithms, and industry trends to ensure your SEO strategy remains relevant and effective. We fine-tune content, keywords, and technical aspects to keep your website optimized, ensuring it maintains its top position on search engine results pages (SERPs)',
        },
      ],
    },
  },
  'meta-ads': {
    title: 'Facebook, Instagram & WhatsApp Advertising',
    // subtitle: 'Turn Clicks Into Customers with Meta Ads',
    description:
      'Unleash the full potential of Meta Ads with precision targeting, engaging creatives, and AI-driven optimization. We design high-converting campaigns that increase brand visibility, drive traffic, and boost ROI.',
    serviceText: {
      title: 'Optimize Your Strategy with High-Impact Meta Ad Formats',
      intro:
        'We optimize campaigns across every Meta ad format, ensuring your brand’s message reaches the right audience in the most engaging way possible.',
      cards: [
        {
          icon: "/allservices/meta/1.png",
          title: 'Image Ads',
          text:
            'Simple, yet effective static ads for brand awareness and engagement.',
        },
        {
          icon: "/allservices/meta/2.png",
          title: 'Video Ads',
          text:
            'High-quality, attention-grabbing video content that drives clicks and conversions.',
        },
        {
          icon: "/allservices/meta/3.png",
          title: 'Carousel Ads',
          text:
            'Swipeable, multi-image ads perfect for showcasing products or services.',
        },
        {
          icon: "/allservices/meta/4.png",
          title: 'Collection Ads',
          text:
            'Create immersive shopping experiences that lead to seamless conversions.',
        },
        {
          icon: "/allservices/meta/5.png",
          title:"Lead Ads",
          text:"Generate high-quality leads directly on Facebook and Instagram with minimal friction.",
        },
        {
          icon: "/allservices/meta/6.png",
          title:"Stories Ads",
          text:"Full-screen, mobile-first ads designed to capture attention instantly."
        }
      ],
    },
    showcaseSection: {
      eyebrow: 'Industries We Impact',
      title: 'Our Meta Ads Marketing Can',
      highlight: 'Deliver Results Across Every Industry',
      intro:
        "From R&C to finance, healthcare to local businesses, we've helped brands of all sizes increase revenue, expand reach, and dominate their industry with strategic Meta ad campaigns.",
      ariaLabel: 'Industries impacted by Meta ads',
      cards: [
        {
          icon: 'heart',
          title: 'Healthcare',
          text: 'We help healthcare brands reach more patients, build trust, and grow their practice.',
        },
        {
          icon: 'cart',
          title: 'Retail & E-commerce',
          text: 'Drive more sales, increase conversions, and maximize ROI for your online store.',
        },
        {
          icon: 'chart',
          title: 'Finance',
          text: 'Generate high-quality leads and build lasting relationships with your ideal customers.',
        },
        {
          icon: 'book',
          title: 'Education',
          text: 'Attract more students, promote courses, and grow enrollment with targeted ad campaigns.',
        },
      ],
    },
  },
  'graphic-designing': {
    title: 'Transform Your Brand with Stunning Graphic Design',
    // subtitle: 'Creative Designs to Captivate, Engage, and Inspire Your Audience',
    description:
      'Create your digital presence with intuitive visuals and user-centric design. Our graphic solutions help your business stand out and convert visitors into customers.',
    serviceText: {
      title: 'Design That Helps You Stand Out',
      intro:
        'Design That Helps You Stand Out',
      cards: [
        {
          icon: "/allservices/graphic/1.png",
          title: 'Logo and Brand Identity Design',
          text:
            'Create a lasting impression with custom logos and branding.',
        },
        {
          icon: "/allservices/graphic/2.png",
          title: 'Print Design',
          text:
            'Engage audiences with stunning, professionally crafted print materials.',
        },
        {
          icon: "/allservices/graphic/3.png",
          title: 'Web and Digital Graphics',
          text:
            'Enhance your online presence with impactful digital graphics',
        },
        {
          icon: "/allservices/graphic/4.png",
          title: ' Packaging Design',
          text:
            'Make your products stand out with unique packaging designs.',
        },
        {
          icon: "/allservices/graphic/5.png",
          title:"Illustration Services",
          text:"Bring your ideas to life with bespoke illustration services."
        },
        {
          icon: "/allservices/graphic/6.png",
          title:"Infographics and Visual Content,",
          text:"Communicate effectively with visually captivating infographics and content."
        }
      ],
    },
    showcaseSection: {
      eyebrow: 'Our Design Process',
      titlePrefix: 'Our ',
      inlineHighlight: 'Design',
      titleSuffix: ' Process',
      intro:
        'Transform your digital presence into a modern, user-friendly experience that captivates visitors and breathes new life into your business.',
      variant: 'process',
      ariaLabel: 'Graphic design process',
      cards: [
        {
          icon: 'research',
          title: 'Discovery and Research',
          text: 'We understand your goals, audience, and competitors to gather insights that shape the right strategy.',
        },
        {
          icon: 'lightbulb',
          title: 'Concept Development',
          text: 'We brainstorm ideas and create concepts that align with your brand and engage your audience.',
        },
        {
          icon: 'pencil',
          title: 'Design and Feedback',
          text: 'We design, collaborate, and refine based on your feedback to ensure the perfect visual outcome.',
        },
        {
          icon: 'rocket',
          title: 'Finalization and Delivery',
          text: 'We finalize every detail and deliver high-quality designs that bring your vision to life.',
        },
      ],
    },
  },
  'youtube-ads': {
    title: 'Engage, Convert, Scale with Video',
    // subtitle: 'Drive Results with YouTube Ads Marketing',
    description:
      'Capture attention, drive conversions, and maximize brand visibility with YouTube ad campaigns. We leverage strategic targeting and compelling storytelling to deliver measurable business results.',
    serviceText: {
      title: 'Choose the Ad Format That Fits Your Goals',
      intro:
        'We specialize in every YouTube ad format to align with your marketing goals – whether it’s brand awareness, engagement, or direct conversions.',
      cards: [
        {
          icon: "/allservices/youtub/1.png",
          title: 'Non-Skippable In-Stream Ads',
          text:
            'Plays before, during, or after videos and cannot be skipped, ensuring full message delivery.',
        },
        {
          icon: "/allservices/youtub/2.png",
          title: 'Bumper Ads',
          text:
            'Short, 6-second, non-skippable ads built for quick impact and maximum brand recall.',
        },
        {
          icon: "/allservices/youtub/3.png",
          title: 'In-Feed Video Ads',
          text:
            'Appear in search results and recommendations, ideal for promoting organic video content.',
        },
        {
          icon: "/allservices/youtub/4.png",
          title: 'Masthead Ads',
          text:
            'Premium homepage banner ads for high-visibility brand awareness on desktop and mobile.',
        },
        {
          icon: "/allservices/youtub/5.png",
          title:"YouTube Shorts Ads",
          text:"Optimized for YouTube Shorts, delivering high-engagement, vertical-format video advertising."
        },
        {
          icon: "/allservices/youtub/6.png",
          title:"Outstream Ads",
          text:"Mobile-focused ads that run outside of YouTube, expanding reach on Google's video network."
        }
      ],
    },
    showcaseSection: {
      titlePrefix: '',
      inlineHighlight: 'YouTube Ads',
      titleSuffix: ' for Every Industry',
      intro:
        "From eCommerce to SaaS, automotive to healthcare, we've helped businesses across industries drive brand awareness, generate leads, and scale revenue with YouTube Ads. No matter your market, we create tailored campaigns that get results.",
      ariaLabel: 'YouTube ads industries',
      cards: [
        {
          icon: 'heart',
          title: 'Healthcare',
          text: 'Reach more patients, build trust, and promote your healthcare services effectively.',
        },
        {
          icon: 'cart',
          title: 'Retail & E-commerce',
          text: 'Drive more sales and conversions by reaching shoppers at every stage of their journey.',
        },
        {
          icon: 'chart',
          title: 'Finance',
          text: 'Generate quality leads and build strong relationships with the right audience.',
        },
        {
          icon: 'book',
          title: 'Education',
          text: 'Attract more students, promote courses, and grow enrollment with targeted campaigns.',
        },
      ],
    },
  },
}

export default servicesData
